import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
} from '@angular/core';
import { UiOwnerTone } from '../../types/ui-owner-tone.type';
import { UiAvatarComponent } from '../ui-avatar/ui-avatar.component';

@Component({
  selector: 'ui-avatar-button',
  imports: [UiAvatarComponent],
  templateUrl: './ui-avatar-button.component.html',
  styleUrl: './ui-avatar-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiAvatarButtonComponent {
  public readonly initials: InputSignal<string> = input.required<string>();
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly tone: InputSignal<UiOwnerTone> = input<UiOwnerTone>('neutral');
  public readonly size: InputSignal<number> = input<number>(32);
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly pressed: OutputEmitterRef<void> = output<void>();

  protected handlePressed(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.pressed.emit();
  }
}
